module.exports = __webpack_public_path__ + "static/media/IMG_6980 edit.158429af.jpg";